const generateNewContentPage = () => {
  return {
    contentPage: null,
    image: null,
    subtitle: '',
    summary: '',
  };
};

const errKeys = {
  contentPage: 'contentPage',
  image: 'image',
  subtitle: 'subtitle',
  summary: 'summary',
  contentPageInvalid: 'contentPageInvalid',
};

export { generateNewContentPage, errKeys };
